import React, { memo } from 'react';
import { Button } from './Button';
import { ShieldCheck, Lock, Zap, Globe, Check } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
const BASE_URL = 'https://kit-online-2026.myshopify.com/cart/44581699879047:1';
const PREMIUM_URL = 'https://kit-online-2026.myshopify.com/cart/44581703417991:1';
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-4 py-9 px-4 bg-brand-cream" data-id="element-162">
      <div className="max-w-6xl mx-auto" data-id="element-163">
        <div className="text-center mb-6" data-id="element-164">
          <h2 className="text-3xl md:text-5xl font-display font-bold text-white uppercase leading-tight" data-id="element-165">
            Elegí el plan que{' '}
            <span className="orange-text" data-id="element-166">mejor se adapta a vos:</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 max-w-5xl mx-auto" data-id="element-167">
          {/* BASE — PLAN DOCENTE */}
          <div className="bg-brand-paper border border-brand-line rounded-xl p-5 md:p-7 flex flex-col relative brunson-shadow" data-id="element-168">
            <div className="text-center mb-3" data-id="element-169">
              <p className="text-brand-green font-display font-bold uppercase text-xs tracking-widest" data-id="element-170">
                ✅ Plan Docente
              </p>
              <h3 className="font-display text-xl md:text-2xl font-bold text-white uppercase leading-tight mt-1" data-id="element-171">
                Formación Integral
              </h3>
              <p className="text-sm text-brand-mute font-medium mt-1" data-id="element-172">
                Todo lo que necesitás para transformar tus clases desde el
                primer día
              </p>
            </div>

            <ul className="space-y-2 mb-4 flex-grow" data-id="element-173">
              {['6 Tomos Maestros (500+ páginas)', 'Bono 1 — 50 Actividades Listas', 'Bono 2 — Evaluaciones y Rúbricas', 'Bono 3 — Proyectos Prácticos', 'Bono 4 — Planificación Anual Editable', 'Actualizaciones de por vida'].map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-174">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-green shrink-0 mt-0.5" strokeWidth={3} data-id="element-175" />
                  <span className="text-sm md:text-base text-brand-ink font-medium" data-id="element-176">
                    {f}
                  </span>
                </li>)}
            </ul>

            <div className="bg-brand-creamAlt rounded-lg p-3 text-center mb-4 border border-brand-line" data-id="element-177">
              <p className="text-xs text-brand-mute font-bold uppercase" data-id="element-178">
                Valor total: <span className="line-through" data-id="element-179">USD 265</span>
              </p>
              <p className="font-display text-4xl md:text-5xl font-bold orange-text leading-none mt-1" data-id="element-180">
                🔥 USD 19,90
              </p>
              <p className="text-[11px] text-brand-mute font-medium mt-1" data-id="element-181">
                Pago único · Sin suscripciones · Acceso inmediato
              </p>
            </div>

            <Button href={BASE_URL} data-id="element-182">🚀 Sí, Quiero el Plan Docente</Button>
            <Trust data-id="element-183" />
          </div>

          {/* PREMIUM — PLAN INSTITUCIONAL */}
          <div className="bg-brand-paper rounded-xl p-5 md:p-7 flex flex-col relative border-2 border-brand-orange shadow-[0_8px_30px_rgba(255,122,26,0.25)]" data-id="element-184">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-orange text-white font-display font-bold text-xs md:text-sm tracking-widest px-4 py-1.5 rounded-full uppercase whitespace-nowrap shadow-lg" data-id="element-185">
              ⭐ 90% de los docentes elige este plan
            </div>

            <div className="text-center mb-3 mt-2" data-id="element-186">
              <p className="text-brand-orange font-display font-bold uppercase text-xs tracking-widest" data-id="element-187">
                🏅 Plan Institucional
              </p>
              <h3 className="font-display text-xl md:text-2xl font-bold text-white uppercase leading-tight mt-1" data-id="element-188">
                Experticia de Élite
              </h3>
              <p className="text-sm text-brand-mute font-medium mt-1" data-id="element-189">
                Para el docente y la institución que quieren ir más lejos que el
                resto
              </p>
            </div>

            <p className="text-xs md:text-sm text-brand-ink font-bold mb-2 uppercase tracking-wide" data-id="element-190">
              Todo lo anterior, más 💎 Mega Banco Acuícola Pro:
            </p>
            <p className="text-xs text-brand-mute italic font-medium mb-3 leading-snug" data-id="element-191">
              El material con el que operan las grandes granjas industriales,
              traducido al aula técnica:
            </p>
            <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-192">
              {[{
              t: 'Simulaciones de Crisis en Tiempo Real',
              d: '— El aula simula la granja real bajo presión'
            }, {
              t: 'Dossiers de Granjas Reales',
              d: '— Datos crudos para que tus alumnos decidan como gerentes'
            }, {
              t: '100 Preguntas de Élite',
              d: '— Razonamiento profesional avanzado (cero memoria)'
            }, {
              t: 'Desafíos Técnicos Extremos',
              d: '— Soluciones creativas a límites biológicos y de presupuesto'
            }, {
              t: '20 Estudios de Caso Reales',
              d: '— Crisis históricas con datos, cronologías y análisis'
            }, {
              t: 'Dinámicas Profesionales Avanzadas',
              d: '— Juicios sectoriales, cumbres y hackathons'
            }, {
              t: 'Proyectos de Élite',
              d: '— Del turnaround de una granja en crisis al diseño de política sectorial'
            }].map((f, i) => <li key={i} className="flex items-start gap-2" data-id="element-193">
                  <Check className="w-4 h-4 md:w-5 md:h-5 text-brand-orange shrink-0 mt-0.5" strokeWidth={3} data-id="element-194" />
                  <span className="text-xs md:text-sm text-brand-ink leading-snug" data-id="element-195">
                    <span className="font-bold text-white" data-id="element-196">{f.t}</span> {f.d}
                  </span>
                </li>)}
            </ul>

            <div className="bg-brand-orangeSoft border border-brand-orange rounded-lg p-3 text-center mb-4" data-id="element-197">
              <p className="text-xs text-brand-mute font-bold uppercase" data-id="element-198">
                Valor total: <span className="line-through" data-id="element-199">USD 562</span>
              </p>
              <p className="font-display text-4xl md:text-5xl font-bold orange-text leading-none mt-1" data-id="element-200">
                🔥 USD 23,90
              </p>
              <p className="text-[11px] text-white font-bold mt-1" data-id="element-201">
                Solo USD 4 más que el Plan Docente
              </p>
            </div>

            <Button href={PREMIUM_URL} data-id="element-202">
              🚀 Sí, Quiero el Plan Institucional de Élite
            </Button>
            <Trust data-id="element-203" />
          </div>
        </div>

        <p className="text-center text-[11px] md:text-xs text-brand-mute font-medium mt-5 max-w-3xl mx-auto leading-snug" data-id="element-204">
          El precio está expresado en dólares estadounidenses (USD). El cobro se
          realiza automáticamente en la moneda de tu país al tipo de cambio del
          momento de la compra. Podés pagar con Mercado Pago o tu método de pago
          local habitual.
        </p>
      </div>
    </section>;
}
function Trust() {
  return <div className="flex flex-wrap justify-center gap-2 md:gap-3 mt-3 text-[10px] md:text-xs font-bold text-brand-ink uppercase tracking-wide" data-id="element-205">
      <div className="flex items-center" data-id="element-206">
        <Lock className="w-3 h-3 mr-1 text-brand-green" data-id="element-207" /> Pago seguro
      </div>
      <div className="flex items-center" data-id="element-208">
        <Zap className="w-3 h-3 mr-1 text-brand-green" data-id="element-209" /> Acceso 5 min
      </div>
      <div className="flex items-center" data-id="element-210">
        <Globe className="w-3 h-3 mr-1 text-brand-green" data-id="element-211" /> Pago local
      </div>
      <div className="flex items-center" data-id="element-212">
        <ShieldCheck className="w-3 h-3 mr-1 text-brand-green" data-id="element-213" /> Garantía 7
        días
      </div>
    </div>;
}